

// object to store loaded CSS chunks
var installedCssChunks = {
	826: 0
}
__webpack_require__.f.compat = (chunkId, promises) => {


	// mini-css-extract-plugin CSS loading
	var cssChunks = {"34":1,"120":1,"340":1,"408":1,"845":1,"912":1,"942":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
			var href = "" + {"18":"38babe15f4ce50d9c885","34":"6c14f9bf4047b525a9a7","37":"74fdc0d17efeead6c439","88":"7eed7903d30c166f6694","119":"c477cafaac0e16795e75","120":"a314d2a02ba704522852","159":"8a9a1ff79afb3753d581","340":"12a64b6376f8f9f8ff08","346":"5e9d009cbe9be3a4d6e6","362":"1fe8050c5ae1008d7fbf","373":"68f43a932c5e92d99500","378":"0d69532214df901ae851","406":"266f864e2dd5ffee81b6","408":"756ab797aecc067dc40e","413":"e7ca8f8769b2b63871c5","422":"b48dcdbcca0c7557b7f4","459":"a0271dfb49068027fa34","464":"cf28eaf7ed3dc5781098","495":"dad5311ae2adf8113530","557":"675c13f728fa8c90d76f","578":"664494d6ee7bee63fd4d","586":"5564c8d37588cab9d037","603":"bdbf8d6144eed4e54f4b","737":"86a0f394427cf11f934b","770":"0caa5c01c75689354004","781":"67e9cb4170cf064c2f67","786":"c474dccac8297591e4a9","827":"27164e0df249631e9ba8","831":"cee83b52efc40d88b6bb","845":"8a9e26d4717420713f3e","848":"1c62b29d5f34bd1c0050","850":"98a3e46dcdae9c1384cd","863":"ba99d72acaad2ddf20c5","877":"fa790a5997632e2c4523","894":"6515ec87a464d24aa1ba","897":"e1634c6cc6e6dd8b51dd","912":"48d9333b38160fd82b1c","942":"d6a4ff42089d1f792bb0","970":"7c52712498801315a8d8"}[chunkId] + "/style.css";
			var fullhref = __webpack_require__.p + href;
			var existingLinkTags = document.getElementsByTagName("link");
			for(var i = 0; i < existingLinkTags.length; i++) {
				var tag = existingLinkTags[i];
				var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
				if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
			}
			var existingStyleTags = document.getElementsByTagName("style");
			for(var i = 0; i < existingStyleTags.length; i++) {
				var tag = existingStyleTags[i];
				var dataHref = tag.getAttribute("data-href");
				if(dataHref === href || dataHref === fullhref) return resolve();
			}
			var linkTag = document.createElement("link");
			linkTag.rel = "stylesheet";
			linkTag.type = "text/css";
			linkTag.onload = resolve;
			linkTag.onerror = function(event) {
				var request = event && event.target && event.target.src || fullhref;
				var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
				err.request = request;
				delete installedCssChunks[chunkId]
				linkTag.parentNode.removeChild(linkTag)
				reject(err);
			};
			linkTag.href = fullhref;
			var head = document.getElementsByTagName("head")[0];
			head.appendChild(linkTag);
		}).then(function() {
			installedCssChunks[chunkId] = 0;
		}));
	}
};